var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineMoire = function SvgLineMoire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 700,
    viewBox: "-2.4 -2.1 4.8 4.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Line_Moire_svg__moire_arc_single",
    fill: "#000",
    stroke: "none",
    d: "M0 0v2h.052l-.104-4H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Line_Moire_svg__moire_arc_group"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(9)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(12)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(18)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(21)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(24)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(27)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(33)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(36)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(39)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_single",
    transform: "rotate(42)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group",
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group",
    transform: "rotate(135)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "60s",
    from: 360,
    repeatCount: "indefinite",
    to: 0,
    type: "rotate"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group",
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Line_Moire_svg__moire_arc_group",
    transform: "rotate(135)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "60s",
    from: 0,
    repeatCount: "indefinite",
    to: 360,
    type: "rotate"
  }))));
};
export { SvgLineMoire as ReactComponent };
export default "data:image/svg+xml;base64,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";